import { useQuery } from '@tanstack/react-query';
import { FieldValues } from 'react-hook-form';

import { patentMembershipOptions } from '@/module/Nomen/PatentMembership/model/PatentMembershipModel';

import { AsyncSelectControl, AsyncSelectControlProps } from '@/core/components';

type PatentMembershipSelectControlProps<T extends FieldValues> = Omit<
  AsyncSelectControlProps<T>,
  'isError' | 'isLoading' | 'options'
>;

export function PatentMembershipSelectControl<T extends FieldValues>(props: PatentMembershipSelectControlProps<T>) {
  const { data, isLoading, isError } = useQuery(patentMembershipOptions.getAll());

  return (
    <AsyncSelectControl
      isError={isError}
      isLoading={isLoading}
      options={data ?? []}
      {...props}
    />
  );
}
